import { Modal } from "react-bootstrap"
import React from "react"
// import { render } from "react-dom";
import warning from "../../Assets/Images/Modal/warning.png"
import ReactLoading from "react-loading"

//css
import "./Modal.css"

function VoidModal(props) {
  return (
    <div>
      <Modal
        show={props.show}
        onHide={props.onHide}
        size="lg"
        centered
        backdrop="static"
      >
        <Modal.Header closeButton />
        <Modal.Body>
          <div className="text">
            <h1> WARNING! </h1>
            <div className="text-wrapper">
              <div className="text-group delete-text">
                <h2>Are you sure you want to void this sales payment?</h2>
                <h3>You can’t undo this action. </h3>
              </div>
              <img
                src={warning}
                alt="warning"
                className="warning delete-warning"
              ></img>
            </div>
            <div className="col-sm-12 mt-3 d-flex justify-content-end">
              <button className="button-secondary me-3" onClick={props.onHide}>
                Cancel
              </button>
              {props.isClicked === true && (
                <div className="button-warning-fill d-flex justify-content-center">
                  <ReactLoading
                    type="bubbles"
                    color="#FFFFFF"
                    height={30}
                    width={30}
                  />
                </div>
              )}
              {props.isClicked === false && (
                <button className="button-primary" onClick={props.onDelete}>
                  Proceed
                </button>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}

VoidModal.defaultProps = {
  text: "",
  show: () => {},
  onHide: () => {},
  onDelete: () => {},
}

export default VoidModal